import { useMutation } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

export type CreateIngredientSupplierLink = {
    ingredient: IRI;
    supplier: IRI;
    organizationId: number;
};

export type DeleteIngredientSupplierLink = {
    linkIri: IRI;
    organizationId: number;
};

export const useCreateIngredientSupplierLink = () =>
    useMutation({
        mutationFn: async ({ ingredient, supplier, organizationId }: CreateIngredientSupplierLink) =>
            await loggedInApiCall.post(
                "/api/ingredient_suppliers",
                { ingredient, supplier },
                { params: { organization_id: organizationId } },
            ),
    });

export const useDeleteIngredientSupplierLink = () =>
    useMutation({
        mutationFn: async ({ linkIri, organizationId }: DeleteIngredientSupplierLink) =>
            await loggedInApiCall.delete(linkIri, { params: { organization_id: organizationId } }),
    });
